import React, {
	memo,
	useCallback,
	useMemo
} from 'react';
import PropTypes from 'prop-types';
import {
	Checkbox,
	Form
} from 'semantic-ui-react';

import { log } from '../../services/utils';

const FormCheckboxGroup = ( {
	align = 'left',
	errors = [],
	fieldLabel,
	forceValidation,
	name,
	onChange,
	options,
	readOnly,
	required,
	value,
	width,
	...props
} ) => {
	const isInvalid = useCallback(
		() => forceValidation
			? errors.some( error => error.error )
			: false,
		[ errors, forceValidation ]
	);

	const handleChange = useCallback( ( e, data ) => {
		const updatedValue = value.includes( data.value )
			? value.filter( v => v !== data.value )
			: [ ...value, data.value ];

		onChange( {
			target: {
				name: data.name,
				value: updatedValue
			}
		} );
	}, [ onChange, value ] );

	const mapOptions = useCallback( () => options.map( option => (
		<Form.Field
			inline
			key={ option.text }
		>
			<Checkbox
				checked={ value.includes( option.value ) }
				label={ option.text }
				name={ name }
				onChange={ handleChange }
				readOnly={ readOnly }
				value={ option.value }
				{ ...props }
			/>
		</Form.Field>
	) ), [
		handleChange,
		name,
		options,
		props,
		readOnly,
		value
	] );

	const alignment = useMemo(
		() => align === 'right'
			? { marginLeft: 'auto' }
			: {},
		[ align ]
	);

	return (
		<>
			{ log( `- ${ name } group checkbox` ) }
			<Form.Field
				error={ isInvalid() }
				required={ required }
				style={ {
					...alignment,
					display: 'flex',
					flexDirection: 'column'
				} }
				width={ width }
			>
				<Form.Group
					grouped
					style={ {
						marginBottom: 0,
						flexGrow: 1
					} }
				>
					<label>{ fieldLabel }</label>
					{ options.length > 10
						? <div
							style={ {
								border: '1px solid rgba(0, 0, 0, 0.1)',
								height: '237.97px',
								marginTop: '6px',
								overflowY: 'auto',
								padding: '0 6px'
							} }
						>
							{ mapOptions() }
						</div>
						: mapOptions()
					}
				</Form.Group>
			</Form.Field>
		</>
	);
};

FormCheckboxGroup.propTypes = {
	align: PropTypes.string,
	errors: PropTypes.arrayOf( PropTypes.shape( {
		error: PropTypes.bool,
		message: PropTypes.node
	} ) ),
	fieldLabel: PropTypes.node.isRequired,
	forceValidation: PropTypes.bool,
	name: PropTypes.string.isRequired,
	onChange: PropTypes.func,
	options: PropTypes.arrayOf( PropTypes.object ).isRequired,
	readOnly: PropTypes.bool,
	required: PropTypes.bool,
	value: PropTypes.array.isRequired,
	width: PropTypes.number
};

export default memo( FormCheckboxGroup );
